import { formatCurrency, getCurrencySymbol } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

/**
 * A price as an amount of money: `€12.50` (`12,50 €` in pt).
 *
 * The backoffice's `customCurrency` pipe, with the locale as an argument rather
 * than `LOCALE_ID`: the language changes at runtime here, and passing
 * `i18n.locale()` is what re-runs a pure pipe when it does (same convention as
 * `unitPrice`, which covers the per-unit form `12.50 €/m`).
 *
 * Every price on screen goes through this pipe — two decimals is the default and
 * the only shape a price is shown in, so a price never renders rounded to whole
 * euros on one screen and to cents on the next. `null` renders as an empty
 * string; a caller wanting a dash renders it itself.
 */
@Pipe({
  name: 'customCurrency',
  standalone: true,
})
export class CustomCurrencyPipe implements PipeTransform {
  transform(
    value: number | null | undefined,
    locale: string,
    currency: string | null | undefined = 'EUR',
    digitsInfo = '1.2-2'
  ): string {
    if (value == null) {
      return '';
    }

    // A record's own currency column is nullable, so an absent one falls back rather than
    // reaching `getCurrencySymbol` as null and printing the word.
    const code = currency || 'EUR';

    return formatCurrency(value, locale, getCurrencySymbol(code, 'narrow', locale), code, digitsInfo);
  }
}
